
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/launch-landing",
      function () {
        return require("private-next-pages/launch-landing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/launch-landing"])
      });
    }
  